module.exports = __webpack_public_path__ + "static/media/bg_rectangle-light-3.65b01a7d.jpeg";